/**
 * Praktikumsfortschritt: Schueler mal Fachbereiche, mit Absolviert, Geplant und Soll.
 *
 * Die Matrix selbst ist dieselbe Komponente, die auch die Planung benutzt; sie wird
 * hier nur fest auf die Seite gezeichnet statt in ein Fenster. Damit koennen beide
 * Wege nicht auseinanderlaufen, siehe components/progress-matrix.ts.
 */

import { api } from "../api";
import type { Department, DepartmentGroup, SchoolClass, Student, Kreisverband } from "../types";
import { renderProgressMatrixInto } from "../components/progress-matrix";
import { esc } from "../utils/html";

export async function render(el: HTMLElement): Promise<void> {
  el.innerHTML = `
    <div class="page-header"><h1>Praktikumsfortschritt</h1></div>
    <div id="aw-pm"></div>`;
  const hostEl = el.querySelector<HTMLElement>("#aw-pm")!;
  hostEl.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:200px"><div class="spinner"></div></div>`;

  try {
    // Derselbe Kontext, den die Planung zusammenstellt (siehe pages/planning.ts),
    // nur ohne deren Filter: hier gibt es keinen Zeitraum, aus dem sich eine
    // Vorauswahl ableiten liesse.
    const [students, classes, departments, groups, settings] = await Promise.all([
      api.students.list(),
      api.classes.list(),
      api.departments(),
      api.settings.departmentGroups(),
      api.settings.get(),
    ]) as [Student[], SchoolClass[], Department[], DepartmentGroup[], any];

    const kreisverbandEnabled = settings.drkKreisverbandEnabled ?? false;
    let kreisverbaende: Kreisverband[] = [];
    if (kreisverbandEnabled) {
      try { kreisverbaende = await api.kreisverbaende.list(); } catch { kreisverbaende = []; }
    }

    await renderProgressMatrixInto(hostEl, {
      students, classes, departments,
      groupDeptIds: new Map(groups.filter(g => !g.isCustom).map(g => [+g.id, new Set((g.departments || []).map(d => d.id))])),
      customGroupDeptIds: new Map(groups.filter(g => g.isCustom).map(g => [+g.id, new Set((g.departments || []).map(d => d.id))])),
      kreisverbandEnabled, kreisverbaende,
      filterClasses: [], filterKreisverband: undefined,
    });
  } catch (err: any) {
    hostEl.innerHTML = `<div class="alert alert-error">Der Fortschritt konnte nicht geladen werden: ${esc(err.message)}</div>`;
  }
}
